/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsCustomerReviews = {
    init: function ($section) {
      const $reviewsSlider = $section.find('[data-slider]');

      $reviewsSlider.flickity({
        wrapAround: true,
        initialIndex: 0,
        prevNextButtons: false,
        pageDots: false,
        cellAlign: 'center',
        resize: true // Enable auto-resizing
      });

      // Function to update navigation classes
      const updateNavClasses = function() {
        // Remove previous state
        $reviewsSlider.find('.is-slide-prev, .is-slide-next').removeClass('is-slide-prev is-slide-next');
        
        // Get current selected slide and all slides
        const $selected = $reviewsSlider.find('.is-selected');
        const $allSlides = $reviewsSlider.find('.flickity-slider > *');
        const selectedIndex = $allSlides.index($selected);
        
        // Handle wrap-around for previous slide
        if (selectedIndex === 0) {
          $allSlides.last().addClass('is-slide-prev');
        } else {
          $selected.prev().addClass('is-slide-prev');
        }
        
        // Handle wrap-around for next slide
        if (selectedIndex === $allSlides.length - 1) {
          $allSlides.first().addClass('is-slide-next');
        } else {
          $selected.next().addClass('is-slide-next');
        }
      };

      // Update on settle
      $reviewsSlider.on('settle.flickity', function () {
        $reviewsSlider.flickity('resize');
        updateNavClasses();
      });

      // Also update on select
      $reviewsSlider.on('select.flickity', updateNavClasses);

      // Handle window resize
      $(window).on('resize', function() {
        $reviewsSlider.flickity('resize');
      });

      $section.on('click', '.reviews__nav--prev', function () {
        $reviewsSlider.flickity('previous');
      });

      $section.on('click', '.reviews__nav--next', function () {
        $reviewsSlider.flickity('next');
      });

      // Initialize classes on first load
      setTimeout(function() {
        $reviewsSlider.flickity('resize');
        updateNavClasses();
      }, 100); // Small timeout to ensure proper initialization
    },
    blockSelect: function ($section, blockId) {
      const $reviewsSlider = $section.find('[data-slider]');
      const slideIndex = $('#shopify-section-' + blockId).data('index');
      $reviewsSlider.flickity('select', slideIndex);
    },
    unload: function ($section) {
      const $slider = $section.find('.flickity-enabled');
      $slider.flickity('destroy');
      $('.reviews__nav--prev').off();
      $('.reviews__nav--next').off();
      $(window).off('resize');
    }
  }
  /******/
})();